var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decimal-places"},[_c('input',{attrs:{"size":"2"},domProps:{"value":_vm.decimals},on:{"change":_vm.updateDecimals}})])
}
var staticRenderFns = []

export { render, staticRenderFns }